module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_06_american-village-b0df9fd281715c151d57536f9c135bc4.jpg";